// Slug-naming-convention audit (item 62 / delivery #71).
//
// Powers the AdminOverview "Legacy-named projects (N)" banner and the
// drill-down at /admin/slug-audit. Read-only — the migration plan is
// surfaced as a table of suggested renames, not as a one-click
// auto-rename, because forced renames break bookmarks, CI configs,
// and API-token scopes.

import useSWR from 'swr';

export interface LegacyProject {
  id: string;
  slug: string;
  name: string;
  suggestion: string;
}

export interface LegacyRepo {
  id: string;
  slug: string;
  name: string;
  project_id: string;
  project_slug: string;
  suggestion: string;
}

export interface SlugAuditResponse {
  projects: LegacyProject[];
  repositories: LegacyRepo[];
  rule: {
    regex: string;
    min_len: number;
    max_len: number;
    examples: string[];
  };
}

async function fetcher(url: string): Promise<SlugAuditResponse> {
  const res = await fetch(url, {
    credentials: 'include',
    headers: { Accept: 'application/json' },
  });
  if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
  return res.json();
}

export function useSlugAudit() {
  return useSWR<SlugAuditResponse>('/api/admin/slug-audit', fetcher, {
    shouldRetryOnError: false,
  });
}
